(function () {
    'use strict';

    angular
        .module('governanceProcessModule')
        .directive('grcGovernanceProcess', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addGovernanceProcess = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$state', '$controller', 'recomConstants', function ($scope, $state, $controller, recomConstants) {

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/governanceProcess/grcGovernanceProcess.[Template].tpl.html';
                // Permissions default values
                $scope.boxFeatureRole = $scope.boxFeatureRole || recomConstants.featureRoles;
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'GovernanceProcess';

                $controller('BoxTmplController', { $scope: $scope });
            }],

            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);

                // Show add Governance Process
                scope.hasAddGovernanceProcess = !_.isUndefined(attrs.addGovernanceProcess);

                // Back Context
                scope.backContext = attrs.backContext ? attrs.backContext : 'Home Page';
            }
        }
    }
})();